module.exports = __webpack_public_path__ + "img/score_2.d72ef426.png";